@if (mobileMode) {

<ul
    class="filters-responsive-menu"
    [class.filters-responsive-menu-mobile]="mobileMode"
    [class.filter-toggle]="mobileMode"
    [class.filters-toggle-desktop]="!mobileMode">
    @for (gridFilterGroup of gridFilterGroups; track trackByFilterGroup(idx, gridFilterGroup); let idx = $index) {
    <li [class.filter-toggle-desktop]="!mobileMode" [attr.id]="'toggle-title-' + gridFilterGroup.name">
        <h-grid-toggle
            #gridFilterToggle
            (collapsedChange)="onCollapsedChange($event)"
            [gridFilterGroup]="gridFilterGroup"
            [filterGroupName]="gridFilterGroup.name"
            [collapsed]="gridFilterGroup.name !== filterGroupOpened">
        </h-grid-toggle>
    </li>
    }
</ul>

} @else {

<div class="filters-responsive-menu filters-responsive-menu-desktop">
    <span hSrOnlyNoSnippet [attr.role]="'group'" i18n="@@hermes-global-translations.filter"> filters </span>
    <div class="filters-toggle-desktop-container">
        <ng-container *ngTemplateOutlet="toggle"></ng-container>
    </div>
    <div class="filter-clear-and-sortby-container">
        <div class="filter-clear-container">
            <h-grid-filters-clear></h-grid-filters-clear>
        </div>
        <!-- Grid Result Header - Wrapper SortBy -->
        <div class="header-filters-sortby">
            <h-grid-sort [selectedValue]="selectedValue" (sortChanged)="onSortChanged($event)"></h-grid-sort>
        </div>
    </div>
</div>

}
<ng-template #toggle>
    <ul
        class="filters-responsive-menu"
        [class.filters-responsive-menu-mobile]="mobileMode"
        [class.filter-toggle]="mobileMode"
        [class.filters-toggle-desktop]="!mobileMode">
        @for (gridFilterGroup of gridFilterGroups; track trackByFilterGroup(idx, gridFilterGroup); let idx = $index) {
        <li [class.filter-toggle-desktop]="!mobileMode" [attr.id]="'toggle-title-' + gridFilterGroup.name">
            <h-grid-toggle
                #gridFilterToggle
                (collapsedChange)="onCollapsedChange($event)"
                [gridFilterGroup]="gridFilterGroup"
                [filterGroupName]="gridFilterGroup.name"
                [collapsed]="gridFilterGroup.name !== filterGroupOpened">
            </h-grid-toggle>
        </li>
        }
    </ul>
</ng-template>
